<ion-header class="ion-no-border" mode="ios">
  <ion-toolbar>
    <ion-button fill="clear" slot="start" (click)="close()">
      Close
    </ion-button>
    <ion-title> Generate Key</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div sxPadding="medium" sxCol sxGap="10px" *ngIf="activeSlide === 0">
    <super-input [showCountrySelector]="true" placeholder="Name" label="Auth Key Name" iconStart="key-outline"
      [required]="true" [validate]="true" [(value)]="keyName"></super-input>
    <super-button [action]="generateKey" [showError]="true">
      Generate Key
    </super-button>
  </div>

  <div sxPadding="medium" sxWidth="full" sxCol sxAlign="center" sxGap="10px" *ngIf="activeSlide === 1">
    <ion-icon name="checkmark-circle" sxTextSize="40px" color="success"></ion-icon>
    <h2 sxColor="success" class="mb-4">Auth Key Generated</h2>

    <div sxWidth="full" sxColor="three" sxBackground="light" sxPadding="medium" sxRadius="medium"
      class="flex flex-col gap-2">
      <div sxRow sxAlign="center" sxDistribution="start" sxGap="10px">
        <ion-icon sxTextSize="22px" name="id-card-outline"></ion-icon>
        <h3 class="mt-4">Token ID</h3>
      </div>

      <p sxCursor="pointer" (click)="copyIDToClipboard()" class="text-sm text-gray-600">
        {{ tokenId }}
      </p>
      <div sxRow sxAlign="center" sxDistribution="start" sxGap="10px" class="mt-4">
        <ion-icon sxTextSize="22px" name="key-outline"></ion-icon>
        <h3 sxMargin="0">Secret Key</h3>
      </div>

      <p (click)="copyKeyToClipboard()" sxCursor="pointer" class="text-sm text-gray-600">
        {{ key }}
      </p>
      <p sxColor="danger" sxBorderWidth="1px 0 0" sxBorderColor="one" sxPadding="medium 0 0">
        Save this key in a safe place. You will not be able to see it again.
      </p>
    </div>


    <div sxRow sxWidth="full" sxGap="10px">
      <super-button iconStart="download-outline" [action]="saveKey" [showError]="true" background="light">
        Download key
      </super-button>
      <super-button iconStart="clipboard-outline" [action]="copyKeyToClipboard" [isDefaultLoader]="false"
        background="light">Copy Key
      </super-button>
    </div>


  </div>
</ion-content>